var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"43","height":"37","viewBox":"0 0 43 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('ellipse',{attrs:{"opacity":"0.9","cx":"21.1082","cy":"18.4697","rx":"21.1082","ry":"18.4697","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }